import {confirmPlus} from 'admin/common/custom_confirm'
import {DTMultiselect} from 'admin/common/dt_multiselect'
import {DNICampaignsCreate} from './dni_campaigns_create'
import {DNICampaignsEdit, DNIEditMulti} from './dni_campaigns_edit'

export class DNICampaigns extends HTMLElement {
  constructor() {
    super();
    this.select_all = false;
    this.domain_id = document.querySelector("#object_id").value;
  }
  connectedCallback() {
    this.is_admin = (this.dataset.admin == 'true');
    this.innerHTML = 
      `<style>
        .dni-buttons-row {
          margin-top: 10px
        }
        .dni-buttons-row:nth-child(2) {
          margin-bottom: -30px;
        }
        #dni-management_wrapper .dataTables_filter,
        #dni-management_wrapper .dataTables_filter label {
          float: left;
          padding-left: 6px;
        }
        .dni-delete-link {
        }
        #dni-management a:hover {
          cursor: pointer;
        }
        dni-campaigns td.dni-select-all.sorting_1 input {
          margin-left: -15px;
        }
        dni-campaigns .badge-list {
          margin-left: 20px;
        }
      </style>
      <div class="dni-campaigns-main">
        <filters-slideout data-table-name="dni-management"></filters-slideout>
        <div class="row">
          <div class="col-sm-12">
            <h3>Digital Campaign Management</h3>
            <span>Create or manage digital campaigns and their settings</span>
          </div>
        </div>
        <div class="row dni-buttons">
          <div class="col-sm-12 pull-right dni-buttons-row">
            <button type="button" class="btn btn-primary" id="edit-dni-multi" data-cy="edit-dni-multi" disabled>Edit Selected</button>
            <button id="new-dni" class="btn btn-primary pull-right" data-cy="new-dni"><i class="fa fa-plus"></i> New Digital Campaign</button>
          </div>
          <div class="col-sm-7 pull-right dni-buttons-row">
            <dni-settings-modal></dni-settings-modal>
          </div>
        </div>
        <table id="dni-management" class="table" style="width:100%; display:table;">
            <thead>
                <tr>
                  <th><input name="select_all" value="1" type="checkbox"></th>
                  <th>Name</th>
                  <th>Phone Number to Replace</th>
                  <th>Active</th>
                  <!--th>Numbers Available</th-->
                  <th>Call Recording</th>
                  <th>LeadScore</th>
                  <th>Actions</th>
                  <th>Unformatted Numbers</th>
                  <th>CallShield</th>
                  <th>Text Enabled</th>
                </tr>
            </thead>
        </table>
      </div>
      `;

      this.init();

      this.querySelector('#new-dni').addEventListener('click', function(e) {
        e.preventDefault();
        this.querySelector('.dni-campaigns-main').classList.add('hidden');
        let new_dni = new DNICampaignsCreate(this, this.table.rows().data(), this.is_admin);
        this.appendChild(new_dni);
      }.bind(this))

      this.querySelector('#edit-dni-multi').addEventListener('click', function() {
        let dni_ids = !this.select_all ? this.table.rows().data().filter((row) => { return row["row_selected"] == true}).map(row => row.dni_campaign_id).toArray() : null;
        let multi_edit = new DNIEditMulti(this.domain_id, this.select_all, dni_ids, this.refreshData.bind(this));
        this.querySelector('.dni-campaigns-main').appendChild(multi_edit);
        multi_edit.show();
      }.bind(this))
  }

  init() {
    let domain_id = document.querySelector("#object_id").value;
    let is_admin = this.is_admin;
    this.table = $('#dni-management').DataTable({
      "dom": '<f<"filter_badges_dni-management"><t>lip>',
      "ajax": `/admin/domains/${domain_id}/dni_campaigns`,
      "rowId": 'dni_campaign_id',
      "columns": [
        { // Select All
          data: 'row_selected',
          'searchable':false,
          'orderable':false,
          'width':'1%',
          'className': 'dt-body-center dni-select-all',
          visible: true,
          'render': function (data, type, row){
              return `<input class="select_row" type="checkbox" ${data==true ? "checked" : ""}>`;
          },
          "class": "text-center dni-select-all"
        },
        {
          data: "campaign_name",
          "render": function ( data, type, row ) {
            return data != null ? `<span>${data}</span>` : ''
          },
        },
        { data : "static_number", "visible" : true, "searchable":true, "orderable":true, "className": 'dt-center',
          "render": function ( data, type, row ) {
            return data != null ? data.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : "";
          }},
        // {
        //   "data": ""//numbers available
        // },
        {
          data: "status",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? `<span class="fa ${((data==DNICampaigns.STATUS.ACTIVE) ? "fa-check":"fa-times")}"></span>` : data;
          },
          "class": "text-center"
        },
        {
          data: "call_recording",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? `<span class="fa ${((data==true) ? "fa-check":"fa-times")}"></span>` : data;
          },
          "class": "text-center"
        },
        {
          data: "call_processing_map",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? `<span class="fa ${((data==true) ? "fa-check":"fa-times")}"></span>` : data;
          },
          "class": "text-center"
        },
        {
          "render": function(data, type, row) {
            return `</span><a class="dni-edit-link">Edit&nbsp</a>${is_admin ? `&nbsp|&nbsp <a class="dni-delete-link">Delete</a>` : ``}`;
          },
          "class": "text-center"
        },
        {
          data : "static_number", "visible" : false, "searchable":true, "orderable":true, "className": 'dt-center',
          "render": function ( data, type, row ) {
            return data != null ? `<span>${data}</span>` : ''
          }
        },
        {
          data : "call_shield", "visible" : false, "searchable":true, "orderable":true, "className": 'dt-center',
          "render": function ( data, type, row ) {
            return data != null ? `<span>${data}</span>` : ''
          }
        },
        {
          data : "did_texting_enabled", "visible" : false, "searchable":true, "orderable":true, "className": 'dt-center',
          "render": function ( data, type, row ) {
            return data != null ? `<span>${data}</span>` : ''
          }
        }
      ],
      "order": [[1, 'asc']]
    });

    // Controls the selected rows.
    DTMultiselect.init(this, 'table#dni-management')

    // Edit individual DNI
    $('#dni-management tbody').on('click', 'a.dni-edit-link', function(e) {
      let tr  = $(e.target).closest('tr')
      let campaign_id = this.table.row(tr).data().dni_campaign_id;
      this.hide()
      let editPage = new DNICampaignsEdit(domain_id, campaign_id, this, this.table.rows().data(), this.is_admin);
      this.appendChild(editPage)
    }.bind(this))

    if(this.is_admin) {
      $('#dni-management tbody').on('click', 'a.dni-delete-link', async (e) => {
        if(await confirmPlus(`Are you sure you want to Delete this Campaign?`)) {
          let tr = $(e.target).closest('tr')
          let campaign_id = this.table.row(tr).data().dni_campaign_id;
          if(await this.setStatus(campaign_id, DNICampaigns.STATUS.ARCHIVED)) {
            this.table.row(tr).remove().draw();
            Common.notify('Campaign deleted.', 'success');
          }
        }
      });
    }
  }

  refreshData(deselect_all=false) {
    this.table.ajax.reload();
    if(deselect_all) {
      $('thead input[name="select_all"]', this.table.table().node()).get(0).click();
    }
  }

  show() {
    this.querySelector('.dni-campaigns-main').classList.remove('hidden');
  }

  hide() {
    this.querySelector('.dni-campaigns-main').classList.add('hidden');
  }

  selectAllTrue() {
    this.select_all = true;
  }

  selectAllFalse() {
    this.select_all = false;
  }

  addNewCampaign(data) {
    this.table.row.add(data).draw();
  }

  updateCampaignData(data) {
    this.table.row(`#${data.dni_campaign_id}`).data(data).draw();
  }

  removeCampaign(data) {
    this.table.row(`#${data.dni_campaign_id}`).remove().draw();
  }

  async setStatus(dni_campaign_id, status) {
    let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns/${dni_campaign_id}/status`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'PUT',
      body: JSON.stringify({"status": status})
    })
    return res.ok;
  }
}

DNICampaigns.STATUS = {};
DNICampaigns.STATUS.ACTIVE = 1;
DNICampaigns.STATUS.PAUSED = 2;
DNICampaigns.STATUS.ARCHIVED = 3;

customElements.define('dni-campaigns', DNICampaigns)

class DNISettingsModal extends HTMLElement {
  constructor() {
    super();
    this.domain_id = document.querySelector("#object_id").value;
  }
  async connectedCallback() {
    let res = await fetch(`/admin/domains/${this.domain_id}/edit.json`);
    this.data = await res.json();
    this.innerHTML = 
      `<style>
        dni-settings-modal .modal-dialog {
          width: 450px;
        }
        dni-settings-modal input, dni-settings-modal select {
          margin-bottom: 20px;
        }
      </style>
      <button type="button" class="btn btn-outline-secondary pull-right ${this.data.ddn == 1 ? 'on' : 'off'}" id="dni-settings-btn" data-cy="dni-settings-btn">Digital Campaign Settings</button>
      <div class="modal fade bd-example-modal-sm" id="DNIeditMultiModal" data-cy="dni-edit-multi-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Digital Campaign Settings</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
  
                <div class="col-sm-12" id="dni-campaign-settings">
                  
                </div>
  
                <div class="col-md-12 edit-campaign-buttons">
                  <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-multi-dni-settings">Save</button>
                  <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    this.populateForm();

    this.modal = this.querySelector('.modal');
    this.querySelector('#dni-settings-btn').onclick = this.show.bind(this);
    this.querySelector('.save').onclick = this.save.bind(this);
    this.querySelector('.cancel').onclick = this.cancel.bind(this);
    this.querySelector('.close').onclick = this.cancel.bind(this);
  }

  populateForm() {
    this.querySelector("#dni-campaign-settings").innerHTML = `
                  <label>Domain Name</label>
                  <input type="text" class="form-control domain-name" value="${this.data.domain_name}">
                  <label>Session Length</label>
                  <select class="form-control domain-session-length">
                    <option selected="selected" value="30">30 minutes</option>
                    <option value="60">1 hour</option>
                    <option value="90">1.5 hours</option>
                    <option value="120">2 hours</option>
                    <option value="150">2.5 hours</option>
                    <option value="180">3 hours</option>
                    <option value="210">3.5 hours</option>
                    <option value="240">4 hours</option>
                    <option value="270">4.5 hours</option>
                    <option value="300">5 hours</option></select>
                  </select>
                  <div class="row">
                    <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-gutters" align="right" role="form">
                      <label class="col-md-6" align="left">AutoID JavaScript Enabled</label>
                      <div class="col-md-6"  align="right">
                        <label class="switch">
                          <input type="checkbox" class="form-control switch domain-web-analytics" ${this.data.web_analytics == 1 ? "checked" : ""}>
                          <span data-cy="ai-javascript-switch"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-gutters" align="right" role="form">
                      <label class="col-md-6" align="left">DNI Enabled</label>
                      <div class="col-md-6"  align="right">
                        <label class="switch">
                          <input type="checkbox" class="form-control switch domain-ddn" ${this.data.ddn == 1 ? "checked" : ""}>
                          <span data-cy="ai-javascript-switch"></span>
                        </label>
                      </div>
                    </div>
                  </div>`
    this.querySelector(".domain-session-length").value = this.data.ddn_session_length;
  }

  show(){
    $(this.modal).modal('show');
  }

  cancel(){
    this.populateForm();
    $(this.modal).modal('hide');
  }

  async save(e) {
    let button = e.target;
    button.disabled = true;
    let data = {
      domain_name: this.querySelector(".domain-name").value,
      ddn_session_length: this.querySelector(".domain-session-length").value,
      web_analytics: this.querySelector(".domain-web-analytics").checked ? 1 : 0,
      ddn: this.querySelector(".domain-ddn").checked ? 1 : 0,
    }

    let res = await fetch(`/admin/domains/${this.domain_id}/settings`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'PUT',
      body: JSON.stringify(data)
    })
    button.disabled = false;
    if (!res.ok) // or check for response.status
        throw new Error(res.statusText);
    
    let response = await res.json();
    if(response.success) {
      this.data = data; // Update the data used to keep state.
      Common.notify('Saved Domain Settings.', 'success');
      this.connectedCallback();
      this.cancel();
    } else {
      Common.notify('Unable to save Domain Settings.', 'error');
    }
  }
}

customElements.define('dni-settings-modal',DNISettingsModal)